export const buildNameThatMightIncludeEmptyStrings = (words: (string | undefined)[]): string => {
  return words.filter((word) => !!word).join(', ');
};
